function Collapse(element, options) {
  this.element = element;
  this.openIndeces = [];

  const instance = this;

  const tabs = instance.element.querySelectorAll(".collapse-tab");

  tabs.forEach((tab, index) => {
    const tabButton = tab.querySelector(".collapse-tab-button");
    const contentWrapper = tab.querySelector(".collapse-content-wrapper");
    const content = tab.querySelector(".collapse-content");

    contentWrapper.setAttribute(
        "data-content-height",
        content.clientHeight + "px"
    );

    // Check if this tab has "current_page_item" or "current-menu-parent"
    const isCurrentPage = tab.classList.contains("current_page_item");
    const isMenuParent = tab.classList.contains("current-menu-parent");

    if (isCurrentPage || isMenuParent) {
      // If it does, we want to ensure it's opened initially
      instance.openIndeces.push(index);
    }

    tabButton.addEventListener("click", (e) => {
      e.preventDefault();
      if (instance.openIndeces.includes(index)) {
        instance.openIndeces = instance.openIndeces.filter((i) => i !== index);
      } else {
        instance.openIndeces.push(index);
      }

      instance.update();
    });
  });

  // Initial update to set the state based on openIndeces
  instance.update();

  return instance;
}

Collapse.prototype.update = function () {
  const instance = this;
  const tabs = instance.element.querySelectorAll(".collapse-tab");
  tabs.forEach((tab, index) => {
    const tabButton = tab.querySelector(".collapse-tab-button");
    const openClassForButton = tabButton.getAttribute("data-open-class") || "";

    const contentWrapper = tab.querySelector(".collapse-content-wrapper");

    if (instance.openIndeces.includes(index)) {
      tab.classList.add("collapse-tab--open");
      if (openClassForButton) {
        tabButton.querySelector("span.icon-plus").classList.add(openClassForButton);
      }
      contentWrapper.style.height = contentWrapper.getAttribute("data-content-height");
    } else {
      tab.classList.remove("collapse-tab--open");
      if (openClassForButton) {
        tabButton.querySelector("span.icon-plus").classList.remove(openClassForButton);
      }
      contentWrapper.style.height = "0px";
    }
  });
};
